import { Box, Button, Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Control, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../../shared/functions/handleError";
import { usePagination } from "../../../shared/hooks/usePagination";
import { IClient } from "../../../shared/interfaces/client/IClient";
import { IInvoice } from "../../../shared/interfaces/invoice/IInvoice";
import { ClientService } from "../../client/service";
import InvoiceFrom from "./InvoiceFrom";
import InvoiceItemDetails from "./InvoiceItemDetails";
import InvoiceSchedule from "./InvoiceSchedule";
import InvoiceTo from "./InvoiceTo";

interface IProps {
  isUpdate?: boolean;
  control: Control<IInvoice>;
  watch: UseFormWatch<IInvoice>;
  setValue: UseFormSetValue<IInvoice>;
}
const InvoiceForm = ({ isUpdate, control, watch, setValue }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pagination, changeFilterHandler } = usePagination({
    perPage: 30,
  });
  const [clients, setClients] = useState<IClient[]>([]);

  useEffect(() => {
    ClientService.get(pagination)
      .then((response) => {
        setClients(response?.data);
      })
      .catch(handleError);
  }, [pagination]);

  return (
    <Card>
      <Box sx={{ padding: { md: "20px" } }}>
        <InvoiceFrom />
        <InvoiceTo
          clients={clients}
          watch={watch}
          control={control}
          changeFilterHandler={changeFilterHandler}
        />
        <InvoiceSchedule control={control} />
        <InvoiceItemDetails
          control={control}
          setValue={setValue}
          clients={clients}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant={"contained"}
          color={"secondary"}
          sx={{ marginTop: "20px" }}
          type={"button"}
          onClick={() => navigate(-1)}
        >
          {t("button.cancel")}
        </Button>

        <Button
          variant={"contained"}
          sx={{ margin: "20px 0 0 10px" }}
          type={"submit"}
        >
          {t(isUpdate ? "button.update" : "button.create")}
        </Button>
      </Box>
    </Card>
  );
};

export default InvoiceForm;
